import Vue from "vue";

//调用全局方法+api
import func from "@/assets/js/func";
import api from "@/assets/js/api";
import socket from "@/assets/js/socket";
import KtApi from "@/assets/js/KtApi";
import JxApi from "@/assets/js/JxApi";
import TzUntil from "@/assets/js/TzUntil";
import storage from "@/assets/js/storage.js";



//全局调用
Vue.prototype.$func = func;
Vue.prototype.$api  = api;
Vue.prototype.$ws   = socket;
Vue.prototype.$KtApi = KtApi;
Vue.prototype.$JxApi = JxApi;
Vue.prototype.$TzUntil = TzUntil;
Vue.prototype.$storage = storage;


